var lib_core  = require("lib-core");
var ui_extensions = require("ui-extensions");

var GroupSelectionModel          = require("./groupSelectionModel.js");
var SelectionController          = require("./../selection/selectionController.js");

var GroupSelectionInteraction = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(GroupSelectionInteraction, lib_core.Controller);
GroupSelectionInteraction.inject = {
    editorController : ui_extensions.AbstractEditorController,
    selectionController : SelectionController
};

module.exports = GroupSelectionInteraction;

GroupSelectionInteraction.prototype.createModel = function () {
    var selectionModel = this.selectionController.getModel();
    return new GroupSelectionModel(selectionModel, this.editorController.getModel(), this.configuration);
};
